// @flow
import React, { Component } from 'react'
import Select from 'react-select'
import { connect } from 'react-redux'
import styles from './categoryTags.less'
import * as actions from '../actions'
import { getUseCases } from '../selectors'
import TagValue from './TagValue'

const TAG_LIMIT = 10000
class UseCases extends Component {
  props: {
    // action creators
    fetchUseCasesIfNeeded: Function,
    putOrgUseCases: Function,
    // from state
    options: Array<Object>,
    value: Array<Object>,
    isFetching: boolean,
    id: number,
    disabled: boolean,
    isPutting: boolean,
    putError: Object,
  }
  state: {
    value: ?Array<Object>,
  }

  componentWillMount() {
    this.props.fetchUseCasesIfNeeded()
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.putError) {
      this.setState({ value: null })
    }
  }

  render() {
    const {
      id,
      isFetching,
      options,
      value,
      disabled,
      putOrgUseCases,
      isPutting,
      putError,
    } = this.props
    let newVal = value
    if (this.state && this.state.value) {
      newVal = this.state.value
    }
    const isLimitReached = newVal.length >= TAG_LIMIT
    return (
      <div className={styles.select}>
        <Select
          name="tags"
          isLoading={isFetching || isPutting}
          placeholder="Add org use cases"
          multi
          disabled={disabled}
          options={isLimitReached ? [] : options}
          noResultsText={
            isLimitReached
              ? 'You have reached the tag limit'
              : 'No use cases found'
          }
          labelKey="name"
          valueKey="id"
          value={newVal}
          valueComponent={TagValue}
          onChange={value => this.setState({ value })}
          onBlur={() => {
            putOrgUseCases({ id, items: newVal.map(item => item.id) })
          }}
        />
        {putError
          ? <div className="bg-danger">
              Error: {putError.response.message}
            </div>
          : null}
      </div>
    )
  }
}

const mapStateToProps = (state, { value }) => {
  const { isFetching, items, isPutting, putError } = getUseCases(state)
  return {
    isFetching,
    isPutting,
    putError,
    options: items,
    value: value || [],
  }
}

export default connect(mapStateToProps, actions)(UseCases)



// WEBPACK FOOTER //
// ./src/components/UseCases.js